<template>
  <div class="app">
    <div class="app__hero">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 435 105"><path d="M1 88.1h5.8c2.9 0 5 2 5 5s-2.1 5.1-5 5.1H3.2v5.9H1v-16zm5.5 8.1c1.9 0 3.1-1.2 3.1-3.1S8.4 90 6.5 90H3.2v6.2h3.3zM31.9 88.1h2.2v14h7.2v1.9h-9.4zM69.2 99.5h-6l-1.6 4.6h-2.3l5.8-16h2.4l5.8 16H71l-1.8-4.6zm-3-9.2s-.4 1.4-.6 2.3l-1.8 5.1h4.8l-1.8-5.1c-.2-.9-.6-2.3-.6-2.3zM92.7 100.5s1.7 1.7 4.1 1.7c1.5 0 2.8-.8 2.8-2.4 0-3.5-7.7-2.7-7.7-7.6 0-2.5 2.2-4.5 5.2-4.5s4.5 1.6 4.5 1.6l-1 1.9s-1.5-1.4-3.5-1.4c-1.7 0-2.9 1.1-2.9 2.3 0 3.3 7.7 2.4 7.7 7.6 0 2.5-1.9 4.5-5.1 4.5-3.4 0-5.3-2.1-5.3-2.1l1.2-1.6zM125.6 90h-5.5v-1.9h13.2V90h-5.5v14h-2.2zM152.7 88.1h2.2v16h-2.2zM183.5 87.8c3.8 0 5.8 2.1 5.8 2.1l-1.1 1.7s-1.9-1.7-4.6-1.7c-3.6 0-5.9 2.7-5.9 6.1s2.4 6.3 5.9 6.3c3 0 4.9-2.1 4.9-2.1l1.2 1.6s-2.2 2.5-6.2 2.5c-4.8 0-8.2-3.7-8.2-8.4.1-4.6 3.6-8.1 8.2-8.1zM233 100.5s1.7 1.7 4.1 1.7c1.5 0 2.8-.8 2.8-2.4 0-3.5-7.7-2.7-7.7-7.6 0-2.5 2.2-4.5 5.2-4.5s4.5 1.6 4.5 1.6l-1 1.9s-1.5-1.4-3.5-1.4c-1.7 0-2.9 1.1-2.9 2.3 0 3.3 7.7 2.4 7.7 7.6 0 2.5-1.9 4.5-5.1 4.5-3.4 0-5.3-2.1-5.3-2.1l1.2-1.6zM262.3 88.1h2.2v10.3c0 2.4 1.6 3.9 4 3.9 2.5 0 4.1-1.4 4.1-3.9V88.1h2.2v10.3c0 3.6-2.6 5.9-6.3 5.9s-6.3-2.4-6.3-5.9l.1-10.3zM296.1 88.1h4.9c1.7 0 2.4.1 3 .4 1.6.6 2.7 2.2 2.7 4.3 0 2-1.1 3.8-2.9 4.3 0 0 .2.2.5.7l3.4 6.2h-2.5l-3.4-6.4h-3.4v6.4h-2.2V88.1h-.1zm5.5 7.6c1.7 0 2.8-1.1 2.8-2.9 0-1.2-.5-2-1.3-2.5-.4-.2-.9-.4-2.2-.4h-2.6v5.7l3.3.1zM334.9 87.8c3.8 0 5.8 1.9 5.8 1.9l-1.1 1.7s-1.8-1.6-4.5-1.6c-3.8 0-6 2.7-6 6.2 0 3.7 2.5 6.3 5.9 6.3 2.8 0 4.5-2 4.5-2V98h-2.6v-2h4.6v8h-2v-1-.7s-1.7 1.9-4.9 1.9c-4.3 0-7.9-3.4-7.9-8.3 0-4.5 3.5-8.1 8.2-8.1zM362.1 88.1h9.3V90h-7v5h5.7v1.9h-5.7v5.1h7.4v1.9h-9.7zM392.3 88.1h4.9c1.7 0 2.4.1 3 .4 1.6.6 2.7 2.2 2.7 4.3 0 2-1.1 3.8-2.9 4.3 0 0 .2.2.5.7l3.4 6.2h-2.5l-3.4-6.4h-3.4v6.4h-2.2V88.1h-.1zm5.4 7.6c1.7 0 2.8-1.1 2.8-2.9 0-1.2-.5-2-1.3-2.5-.4-.2-.9-.4-2.2-.4h-2.6v5.7l3.3.1zM427.2 97.3l-5.4-9.2h2.5l3 5.3c.5.9 1 2 1 2s.5-1.1 1-2l2.9-5.3h2.5l-5.3 9.2v6.8h-2.2v-6.8zM.3 7.5h10v30.1h6.5V7.5h10V2H.3zM57.8 17.1H41.5V2H35v35.6h6.5V22.7h16.3v14.9h6.4V2h-6.4zM82 22.5h10.7v-5.6H82V7.5h15.5V2h-22v35.6h22V32H82zM149 55.6c-13.1 0-21.2-10.6-21.2-22.6 0-11.7 7.8-21.7 21.1-21.7 10 0 17.2 6.7 17.2 6.7l5.5-8.5S163.7.9 148.3.9c-18.6 0-32.4 14-32.4 32.3 0 18.6 13.3 32.9 32.6 32.9 16.1 0 24.8-10.2 24.8-10.2l-6-8.3s-7.4 8-18.3 8zM199.2 2h-11.4v63h38.7v-9.8h-27.3zM240.3 2h11.5v63.1h-11.5zM348.2 2h11.5v63.1h-11.5zM428.7 47.6s-7.4 8-18.3 8c-13.1 0-21.2-10.6-21.2-22.6 0-11.7 7.8-21.7 21.1-21.7 10 0 17.2 6.7 17.2 6.7l5.5-8.5S425.1.9 409.7.9c-18.6 0-32.4 14-32.4 32.3 0 18.6 13.3 32.9 32.6 32.9 16.1 0 24.8-10.2 24.8-10.2l-6-8.3zM314.6 40.3c-3.4-3.8-7.3-7.5-11.1-11-9.7-9-18.6-17.8-18.6-27.3H273v63h11.5V27c3.4 3.8 7.2 7.4 11 10.9 9.6 9 18.8 17.7 18.8 27.1h11.9V2h-11.5v38.3h-.1zM1 55.2h96.5v9.9H1z"></path> <path d="M149 55.6c-13.1 0-21.2-10.6-21.2-22.6 0-11.7 7.8-21.7 21.1-21.7 10 0 17.2 6.7 17.2 6.7l5.5-8.5S163.7.9 148.3.9c-18.6 0-32.4 14-32.4 32.3 0 18.6 13.3 32.9 32.6 32.9 16.1 0 24.8-10.2 24.8-10.2l-6-8.3s-7.4 8-18.3 8z"></path></svg>
      <h1>Component List</h1>
    </div>
    <div class="app__docs">
      <Sidebar :data="elements"/>
      <Docs v-for="el, index in elements" :data="el" :key="`component-${index}`"/>
    </div>
  </div>
</template>

<script>
import ComponentData from '@/assets/component-data.json'
import Sidebar from './components/Sidebar.vue'
import Docs from './components/Docs.vue'

export default {
  name: 'app',
  data(){
    return {
      elements: ComponentData
    }
  },
  components: {
    Sidebar,
    Docs
  }
}
</script>

<style lang="scss">
@import './scss/defaults';
@import './scss/fonts';

.app {
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  flex-direction: column;
  scroll-behavior: smooth;

  &__hero {
    background: #222;
    width: 100%;
    height: 100px;
    // margin-left: 300px;
    display: flex;
    // flex-direction: column;
    // justify-content: center;
    align-items: center;

    h1 {
      font-size: 3rem;
      color: #fff;
      margin-left: 3rem;
      font-weight: 100;

      @media(max-width: 600px){
        font-size: 1.8rem;
      }

    }

    svg {
      width: 30rem;
      fill: #fff;
      padding: 3rem;

      @media(max-width: 600px){
        width: 17rem;
      }

    }

  }

  &__docs {
    flex: 1;
    overflow-y: scroll;
    scroll-behavior: smooth;
  }

}
</style>
